import { useI18n, useMCAInfo } from 'contexts/AuthContext'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ContentHeader from '../ContentHeader'
import CareSelectButton from 'components/CareSelectButton/index'
import { Button } from 'antd'
import { isMobile } from 'utils/basic'
import _ from 'lodash'
import { logAmplitudeEvent } from 'utils/amplitudeInit'
import { ScreenKey } from '../util'
import { useMCA } from './useMCA'
import { useMetadataOptions } from 'hooks/careHooks'

const MSKExclusion = (props) => {
  const { i18n } = useI18n()
  const { sku, setCurrentKey } = props
  const { setMCAInfo, mcaInfo } = useMCAInfo()
  const { getNextScreenKey } = useMCA({ sku })
  const { mskExclusion = [] } = mcaInfo
  const { mcaMskExclusions } = useMetadataOptions()
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    logAmplitudeEvent('Screen View: Onboarding - MSK Exclusion', {
      sku,
    })
  }, [sku])

  const isSelected = (id) => {
    return mskExclusion.some((item) => item.id === id)
  }

  const setSelected = (item) => {
    const isExist = isSelected(item.id)
    if (isExist) {
      setMCAInfo({
        ...mcaInfo,
        mskExclusion: mskExclusion.filter((i) => i.id !== item.id),
      })
    } else {
      if (['None of the above'].includes(item.name)) {
        setMCAInfo({ ...mcaInfo, mskExclusion: [item] })
      } else {
        const newMskExclusion = mskExclusion.filter(
          (i) => !['None of the above'].includes(i.name)
        )
        setMCAInfo({
          ...mcaInfo,
          mskExclusion: [...newMskExclusion, item],
        })
      }
    }
  }

  const isNextButtonEnable = useMemo(() => {
    return !_.isEmpty(mskExclusion)
  }, [mskExclusion])

  const openNextScreen = useCallback(async () => {
    const nextScreenKey = await getNextScreenKey(ScreenKey.MCA_MSK_EXCLUSION)
    setCurrentKey(nextScreenKey)
  }, [setCurrentKey, getNextScreenKey])

  const onSubmit = async () => {
    setIsSubmitting(true)
    logAmplitudeEvent('Click: Onboarding - MSK Exclusion - Submit', {
      sku,
      selections: mskExclusion.map((item) => item.name),
    })

    await openNextScreen()
    setIsSubmitting(false)
  }

  return (
    <div className='info-sec'>
      <ContentHeader {...props} />
      <div className='info-content'>
        <div className='title-pns' style={{ marginBottom: '32px' }}>
          {i18n('Do any of the following currently apply to you?')}
        </div>
        {mcaMskExclusions.map((item, index) => (
          <div key={index}>
            <CareSelectButton
              key={index}
              {...{
                selected: isSelected(item.id),
                setSelected: () => {
                  setSelected(item)
                },
                text: item.name,
                className: 'm-b-12 center-align',
                textAlign: 'center',
              }}
            />
          </div>
        ))}
        <Button
          className='btn-primary full-width-btn'
          style={isMobile() ? { width: '100%' } : {}}
          onClick={onSubmit}
          disabled={!isNextButtonEnable}
          loading={isSubmitting}
        >
          {i18n('Next')}
        </Button>
      </div>
    </div>
  )
}

export default MSKExclusion
